import { supabase } from '../lib/supabaseClient.js';
import { TABLES } from '../lib/constants.js';

export async function listProblemTypes() {
  const { data, error } = await supabase.from(TABLES.PROBLEM_TYPES).select('*').eq('active', true).order('name');
  if (error) throw error;
  return data;
}

export async function addProblemType(name) {
  const { data, error } = await supabase.from(TABLES.PROBLEM_TYPES).insert({ name, active: true }).select().single();
  if (error) throw error;
  return data;
}

export async function deactivateProblemType(id) {
  const { error } = await supabase.from(TABLES.PROBLEM_TYPES).update({ active: false }).eq('id', id);
  if (error) throw error;
}
